<template>
  <div>

    <!-- 저장 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="done">저장하기</button>
    </div>

    <div class="columns is-multiline">
      <div class="column is-8">
        <div class="box">
          <admin-box-item title="공지사항 게시글 등록/수정">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="공지사항 게시글 노출기간">
                  <div class="flex" style="flex-wrap:wrap">
                    <admin-date-picker
                      :data="notice.start_date"
                      @setDate="selDateMin"></admin-date-picker>
                    <div class="lp-dating">&#126;</div>
                    <admin-date-picker
                      :data="notice.end_date"
                      @setDate="selDateMax"></admin-date-picker>
                  </div>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="게시물 노출 여부" tip="게시글 노출 기간과 무관하게 노출/비노출을 설정할 수 있습니다.">
                  <lp-radio :val="notice.enable_post"
                            value_name="value"
                            label_name="label"
                            :data="[{label:'노출',value:true}, {label:'비노출', value:false}]"
                            @onSelect="onSelectedPostState"></lp-radio>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="노출 우선순위" tip="숫자가 낮을 수록 우선순위가 높게 책정되어 먼저 표시되며, 노출 우선순위가 동일한 경우 최신등록순으로 표시됩니다.">
                  <input class="input"
                         :value="notice.priority"
                         @input="e => notice.priority = e.target.value"
                         placeholder="노출 우선순위를 입력하세요. (0~99)"
                         type="text">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="제목*">
                  <input class="input"
                         :value="notice.title"
                         @input="e => notice.title = e.target.value"
                         placeholder="제목을 입력하세요."
                         type="text">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="내용*">
                  <lp-editor :text.sync="notice.content"></lp-editor>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="대표 이미지" tip="프론트 디자인에 따라서 썸네일이 표시될 때 사용하는 이미지로, 프론트 디자인에 따라 사용되지 않을 수도 있습니다.">
                  <input-img :url.sync="notice.img"></input-img>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <div class="box" v-if="$route.query.id">
          <admin-box-item title="공지사항 댓글 등록">
            <!-- 댓글 목록 -->
            <div>
              <div class="comment-sub-title">
                댓글 목록 ({{ commentsArr.length }})
                <i v-if="isComment===false" @click="isComment=true" class="material-icons" style="cursor: pointer;">keyboard_arrow_down</i>
                <i v-if="isComment===true" @click="isComment=false" class="material-icons" style="cursor: pointer;">keyboard_arrow_up</i>
              </div>
              <div style="padding:12px">
                <div
                  v-if="isComment === true"
                  v-for="(item, idx) in commentsArr" :key="'comments'+idx"
                  style="margin-top: 12px;">
                  <div
                    v-if="idx !== 0"
                    style="margin: 15px 0; width: 100%; height: 1px; background: #ddd;"></div>
                  <div style="display:flex; font-size: .9rem; color: #555;">
                    <div style="width: 82%;">
                      <div style="display: flex;">
                        <div style="width: 80px; font-weight: bold;">작성자</div>
                        <div>{{ item.display_name }}</div>
                      </div>
                      <div style="display: flex;">
                        <div style="width: 80px; font-weight: bold;">작성일</div>
                        <div>{{ item.created_time }}</div>
                      </div>
                      <div style="display: flex;">
                        <div style="width: 80px; font-weight: bold;">작성내용</div>
                        <div>{{ item.content }}</div>
                      </div>
                    </div>
                    <div class="buttons" v-if="!item.is_deleted">
                      <button @click="clickUpdate(item)" class="button" style="padding: 6px 10px;">수정</button>
                      <button @click="clickDelete(item)" class="button is-danger" style="padding: 6px 10px;">삭제</button>
                    </div>
                    <div v-else>삭제된 댓글입니다.</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 댓글 작성 -->
            <div>
              <div class="comment-sub-title" style="margin-top:20px;margin-bottom: 20px;">댓글 작성</div>
              <admin-form-item label="작성 내용">
                <div class="flex">
                  <div style="margin-right:12px;width:90%">
                    <textarea class="textarea" v-model="comments.content"></textarea>
                  </div>
                  <div>
                    <button class="button is-primary"
                            style="height: 100% !important;"
                            @click="clickCommentsReg">등록</button>
                  </div>
                </div>
              </admin-form-item>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>

    <!-- 저장 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="done">저장하기</button>
    </div>

  </div>
</template>

<script>
  import AdminBoxItem from "../../module/admin/AdminBoxItem";
  import AdminFormItem from "../../module/admin/AdminFormItem";
  import AdminDatePicker from "../../module/admin/AdminDatePicker";
  import LpRadio from "../../module/common/LpRadio";
  import InputImg from "../../module/common/InputImg";
  import CreateMixin from "@/mixins/CreateMixin"

  export default {
    name: 'NoticeReg',
    layout: "Main",
    components: {
      InputImg,
      LpRadio,
      AdminDatePicker,
      AdminFormItem,
      AdminBoxItem
    },
    mixins: [
      CreateMixin
    ],
    created() {

      // 새로 등록
      if ( this.$route.query.id === undefined ) {
        /*this.notice.start_date = this.resetNewDate('start');
        this.notice.end_date = this.resetNewDate('end');
        this.notice.username = this.$store.getters.admin.username;*/
      }
      // 라우팅
      else {
        this.getData();
        this.getComment();
        this.notice.start_date = this.convertNewDate(this.notice.start_date);
        this.notice.end_date = this.convertNewDate(this.notice.end_date);
      }
    },
    data() {
      return {
        notice: {
          id: 0,
          start_date: '',
          end_date: '',
          enable_post:true,
          // date: {
          //   min: "2017-01-01",
          //   max: "2099-12-31"
          // },
          priority: 99,
          title: "",
          content: "",
          img: ''
        },
        isComment: false, // 댓글 목록 fold/unfold
        // 댓글 목록
        commentsArr: [],
        // 댓글 작성
        comments: {
          id: "", // 상품문의상세 게시글 id
          content: "",
          /*writer: "",
          writer_type: "",
          writer_name: "",
          writer_username: "",
          date: "",
          lock: false // 비밀댓글 여부*/
        },
        // 댓글 작성자 드롭다운 Array
        commentsWriterArr: []
      };
    },
    methods: {
      // 게시판 노출 여부
      onSelectedPostState(val) {
        this.notice.enable_post = val;
      },
      getData() {
        this.$axios.get(this.getUrl('board/notice/' + this.$route.query.id))
          .then(res => {
            let notice = res.data;
            if(!notice.img)
              notice.img = '';
            this.notice = notice;
          });
      },
      getComment() {
        this.$axios.get(this.getUrl('board/notice/' + this.$route.query.id + '/comment'))
          .then(res=>{
            this.commentsArr = res.data.data;
          })
      },
      // 삭제
      clickDelete(item) {
        this.$axios.delete(this.getUrl('board/notice/' + this.$route.query.id + '/comment/' + item.id))
          .then(res=>{
            if(res.status===200){
              this.toast('삭제되었습니다.');
              this.getComment();

              this.comments = {
                id: "",
                content: ""
              }
            }
          })

      },
      // 수정
      clickUpdate(item) {
        this.comments.id = item.id;
        this.comments.content = item.content;

        // this.comments.writer = arr.writer;
        // this.comments.writer_type = arr.writer_type;
        // this.comments.writer_name = arr.writer_name;
        // this.comments.writer_username = arr.writer_username;
        // this.comments.lock = arr.lock;
        // this.comments.date = arr.date;

      },
      // 댓글 등록
      clickCommentsReg() {
        if(!this.comments.id){
          this.$axios.post(this.getUrl('board/notice/'+this.$route.query.id+'/comment'), {
            content: this.comments.content
          }).then(res=>{
            if(res.status===200){
              this.getComment();
              this.comments = {
                id: '',
                content: ''
              }
              if(!this.isComment){
                this.isComment = true;
              }
            }
          })
        }
        else{
          this.$axios.patch(this.getUrl('board/notice/'+this.$route.query.id+'/comment/'+this.comments.id), {
            content: this.comments.content
          }).then(res=>{
            if(res.status===200){
              this.getComment();
              this.comments = {
                id: '',
                content: ''
              }
            }
          })
        }
      },
      // 뒤로가기 (등록 취소)
      clickBack() {
        this.$router.back();
      },
      // 댓글 작성자 선택
      selectCommentsWriter(item) {
        this.comments.writer = item.name + `(${item.username})`;
        this.comments.writer_type = item.type;
        this.comments.writer_name = item.name;
        this.comments.writer_username = item.username;
      },
      selDateMin(val) {
        this.notice.start_date = val;
      },
      selDateMax(val) {
        this.notice.end_date = val;
      },
      priorityKeyUp(value) {
        this.notice.priority = value;
      },
      done() {
        let err = '';
        if ( !this.notice.title ) err = '제목을 입력하세요.';
        else if( !this.notice.content ) err= '내용을 입력하세요.';

        if ( err ) {
          this.toast(err);
          return;
        }

        let value = this.cloneItem(this.notice);
        if(!value.start_date){
          value.start_date = '1111-01-01';
        }
        if(!value.end_date){
          value.end_date = '9999-01-01';
        }

        if(!this.$route.query.id){
          this.$axios.post(this.getUrl('board/notice'), value).then(res=>{
            if(res.status===200){
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath('notice'));
            }
          })
        }
        else {
          this.$axios.patch(this.getUrl('board/notice/'+this.$route.query.id), value).then(res=>{
            if(res.status===200){
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath('notice'));
            }
          })
        }
      }
    }
  };
</script>

<style lang="stylus" type="stylus" scoped>
  ////@import '~assets/css/reset';
  @import '~assets/css/lp_main';

  .comment-sub-title {
    background: #ddd;
    color: #333;
    padding: 8px 16px;
    font-size: 0.95rem;
    border-radius: 3px;
    display: flex;
    justify-content: space-between;
  }

  .event-comment-content {
    padding: 20px;
    font-size: 0.95rem;
    color: #222;
    border-radius: 3px;
    border: none;
    background-color: #f2f7f8;
    display: block;
    width: 100%;
    height: 120px;
  }

  .btn-add-img {
    margin: 0 8px 8px 0;
    background: #f2f7f8;
    width: 80px;
    height: 80px;
    text-align: center;
  }

  .btn-add-img i {
    font-size: 3rem;
    line-height: 80px;
    color: #555;
  }
</style>
